import { styled } from 'styled-components'

export const StyledLogo = styled.img`
  height: 118px;
  width: 195px;
`
